import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import logoImage from '../../assets/images/image 16.png';

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">

      </div>

      {/* ロゴアイコン */}
      <div className="footer-logo">
        <img src={logoImage} alt="BohPJ Logo" />

      </div>

      {/* ナビゲーションリンク */}
      <div>
        <ul className="footer-content">
        <li><Link to="/" className="footer-link">ホーム</Link></li>
        <li><Link to="/news" className="footer-link">ニュース</Link></li>
        <li><Link to="/works" className="footer-link">実績</Link></li>
        <li><Link to="/members" className="footer-link">メンバー</Link></li>
        <li><Link to="/resources" className="footer-link">資料</Link></li>
      </ul>
      </div>

      {/* ソーシャルメディアアイコン */}
      {/* <div className="footer-social-icons">
        <a
        href="https://x.com/saikyounaui?s=21&t=pmNJbU0F1GtQI2FZD4vwoQ"
        target="_blank"
        rel="noopener noreferrer"
        className="footer-link"
        >
        <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        >
        <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932 6.064-6.932zm-1.292 19.494h2.039L6.486 3.24H4.298l13.311 17.407z" />
        </svg>
        </a>
      </div> */}

      {/* 下部：コピーライト */}
      <div className="footer-bottom">
        <p>&copy; 2019-2026 BohPJ</p>
      </div>
    </footer>
  );
};

export default Footer;